<template>
  <div>
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-mb-8">
      <h1>{{ $t('adm.clients.companies.title') }}</h1>
      <i-button
        type="primary"
        size="medium"
        @click="isAddCompanyDialogOpen = true"
      >
        <icon-plus class="tw-mr-2" />
        {{ $t('adm.clients.companies.create_button') }}
      </i-button>
    </div>

    <div v-loading="isLoading">
      <AdministrationCompaniesFilters
        store-path="v2/admin/cms/clients/companies"
        class="tw-mb-8"
      />

      <div
        class="tw-overflow-auto"
      >
        <AdministrationTableList
          store-path="v2/admin/cms/clients/companies"
          list-relative-path="companies"
          list-item-component-name="ClientCompaniesListItem"
          list-item-prop-name="company"
          :columns="columns"
        />
      </div>
      <AdministrationTablePagination
        store-path="v2/admin/cms/clients/companies"
        filter-relative-path="filters"
      />
    </div>

    <AddClientsCompanyDialog
      :is-open="isAddCompanyDialogOpen"
      @close="isAddCompanyDialogOpen = false"
      @refresh="load"
    />
    <ForeignersMessagingPopover />
  </div>
</template>

<script>
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';
import AdministrationTablePagination from '@/components/Administration/components/AdministrationTablePagination.vue';
import AdministrationTableList from '@/components/Administration/components/AdministrationTableList.vue';
import AdministrationCompaniesFilters
  from '@/components/Administration/components/AdministrationCompaniesFilters.vue';
import { clientCompaniesTableColumns } from '@/components/Administration/Client/Companies/constants';
import AddClientsCompanyDialog from '@/components/Administration/Client/Companies/AddClientsCompanyDialog.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ClientCompanies',
  components: {
    AddClientsCompanyDialog,
    AdministrationCompaniesFilters,
    AdministrationTablePagination,
    AdministrationTableList,
    ForeignersMessagingPopover,
  },
  data() {
    return {
      isAddCompanyDialogOpen: false,
    };
  },
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.cms.clients.companies.filters,
      isLoading: (state) => state.v2.admin.cms.clients.companies.isLoading,
    }),
    ...mapGetters({
      isPermitsEmpty: 'v2/admin/cms/permitManagement/permitTypes/selectCaseAssessmentOptionsAreEmpty',
      internalUsersAreEmpty: 'v2/admin/cms/internal/users/selectOptionsAreEmpty',
    }),
    columns: () => clientCompaniesTableColumns,
  },
  watch: {
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
    if (this.internalUsersAreEmpty) {
      this.$store.dispatch('v2/admin/cms/internal/users/loadAllUsers');
    }
    if(this.isPermitsEmpty) {
      this.$store.dispatch('v2/admin/cms/permitManagement/permitTypes/loadAllPermitTypes');
    }
  },
  methods: {
    load() {
      this.$store.dispatch('v2/admin/cms/clients/companies/load');
    },
  },
};
</script>
